import { Fragment, jsx } from "react/jsx-runtime";
import react from "react";
import { Alert } from "../Alert/index.js";
import { Box } from "../Box/index.js";
const SnackbarErrorContent_SnackbarErrorContent = /*#__PURE__*/ react.forwardRef(function({ id, title, subtitle, details, severity, closeSnackbar, ...otherProps }, ref) {
    return /*#__PURE__*/ jsx(Alert, {
        ref: ref,
        ...otherProps,
        severity: severity,
        onClose: ()=>closeSnackbar(id),
        "aria-describedby": "snackbar-err-content",
        sx: {
            minWidth: 300
        },
        Header: /*#__PURE__*/ jsx("div", {
            id: "snackbar-err-content",
            children: title
        }),
        MoreDetails: details ? /*#__PURE__*/ jsx(Fragment, {
            children: details.map((msg, idx)=>/*#__PURE__*/ jsx(Box, {
                    children: msg
                }, idx))
        }) : void 0,
        children: subtitle
    });
});
export { SnackbarErrorContent_SnackbarErrorContent as SnackbarErrorContent };

//# sourceMappingURL=SnackbarErrorContent.js.map